"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.AlertKinds = void 0;
exports.alertKindToFontClass = alertKindToFontClass;
exports.normalizedIndicatorToFontClass = normalizedIndicatorToFontClass;
exports.normalizedIndicatorValues = normalizedIndicatorValues;
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _lodash = require("lodash");
/* Object.defineProperty(exports, "__esModule", {
  value: true
}); */
exports.AlertKinds = undefined;
exports.alertKindToFontClass = alertKindToFontClass;
exports.normalizedIndicatorValues = normalizedIndicatorValues;
exports.normalizedIndicatorToFontClass = normalizedIndicatorToFontClass;
var alertKindToBaseClass = {
  tirePressureMonitorSystemWarning: 'tire-pressure',
  fastenSeatbeltWarning: 'seat-belt',
  airFilterMinder: 'air-filter-minder',
  // antilockBrake: 'anti-lock-brake',
  antiTheft: 'anti-theft',
  brakeWarning: 'brake',
  checkFuelFilter: 'fuel-filter',
  forwardCollisionWarning: 'collision-warning',
  hillDescentControlFault: 'hill-descent-control-fault',
  laneKeepingAid: 'lane-departure',
  lowEngineOilPressure: 'oil',
  // malfunctionIndicator: 'malfunction-indicator,
  // lowFuel: 'low-fuel',
  parkAidMalfunction: 'park-aid-malfunction',
  powertrainMalfunction: 'powertrain-malfunction',
  serviceSteering: 'service-steering',
  adaptiveCruiseControl: 'adaptive-cruise-control',
  allWheelDriveDisabled: 'all-wheel-drive-disabled',
  blindSpotDetection: 'blind-spot-detection',
  // chargeSystemFault: 'charge-system-fault,
  checkFuelCap: 'check-fuel-cap',
  checkFuelFillInlet: 'check-fuel-fill-inlet',
  fuelDoorOpen: 'fuel-door-open',
  lowWasherFluid: 'low-winshield-fluid',
  // startStopEngineWarning: 'start-stop-engine-warning',
  // waterInFuel: 'water-in-fuel
  tractionControlDisabled: 'traction-control'

  // OLD ALERTS****
  // HEADLAMP_ALERT: 'light-on',
  // TIRE_PRESSURE_ALERT: 'tire-pressure',
  // FUEL_CAPACITY_ALERT: 'fuel',
  // CHECK_ENGINE_ALERT: 'engine',
  // ABS_ALERT: 'abs',
  // TRANSMISSION_ALERT: 'transmission',
  // OIL_LEVEL_ALERT: 'oil',
  // PID_BATTERY_ALERT: 'unplugged',
  // //FIXME - THESE ARE FAUX ALERTS THAT THE UI NEEDS TO DISPLAY STATUS
  // PID_UNPLUGGED: 'unplugged',
  // PID_PLUGGED_IN: 'plugged',
  // HOOD_OPEN: 'hood-open',
  // TRUNK_OPEN: 'trunk-open',
  // BATTERY: 'battery',
  // TEMPERATURE: 'temp',
  // GEOFENCE_EVENT: 'geofence-event',
  // IDLING_EVENT: 'idling-event',
  // AIRBAG: 'airbag',
  // BRAKE: 'brake',
  // SEAT_BELT: 'seat-belt',
  // SERVICE: 'service',
  // OPEN_DOOR: 'open-door',
  // LOCK: 'key'
};

function alertKindToFontClass(kind) {
  return 'icon-' + (alertKindToBaseClass[kind] || 'unknown');
}
const AlertKinds = (0, _keys.default)(alertKindToBaseClass);
exports.AlertKinds = AlertKinds;
const indicatorMetadata = {
  abs: {
    fontClass: 'abs',
    indicatorField: 'abs_lamp'
  },
  airbag: {
    fontClass: 'airbag',
    indicatorField: 'airbag_lamp'
  },
  autoSpeedLimiter: {
    fontClass: 'speed-limiter',
    indicatorField: 'automatic_speed_limiter_lamp'
  },
  brakeSystem: {
    fontClass: 'brake',
    indicatorField: 'brake_system_lamp'
  },
  collisionWarning: {
    fontClass: 'collision-warning',
    indicatorField: 'collision_warning_lamp'
  },
  dieselExhaustFluid: {
    fontClass: 'diesel-exhaust-fluid',
    indicatorField: 'diesel_exhaust_fluid_lamp'
  },
  engineCoolantTemp: {
    fontClass: 'engine-coolant',
    indicatorField: 'engine_coolant_temperature_lamp'
  },
  engineWarning: {
    fontClass: 'engine',
    indicatorField: 'engine_warning_lamp'
  },
  ignition: {
    fontClass: 'ignition',
    indicatorField: 'ignition_lamp'
  },
  laneDeparture: {
    fontClass: 'lane-departure',
    indicatorField: 'lane_departure_lamp'
  },
  lowWasherFluid: {
    fontClass: 'low-windshield-fluid',
    indicatorField: 'low_washer_fluid_lamp'
  },
  oilPressure: {
    fontClass: 'oil',
    indicatorField: 'oil_pressure_lamp'
  },
  tirePressureFrontLeft: {
    fontClass: 'tire-pressure',
    indicatorField: 'tire_pressure_lamp.front_left'
  },
  tirePressureFrontRight: {
    fontClass: 'tire-pressure',
    indicatorField: 'tire_pressure_lamp.front_right'
  },
  tirePressureRearLeft: {
    fontClass: 'tire-pressure',
    indicatorField: 'tire_pressure_lamp.rear_left'
  },
  tirePressureRearRight: {
    fontClass: 'tire-pressure',
    indicatorField: 'tire_pressure_lamp.rear_right'
  },
  tirePressureRearOuterLeft: {
    fontClass: 'tire-pressure',
    indicatorField: 'tire_pressure_lamp.rear_outer_left'
  },
  tirePressureRearOuterRight: {
    fontClass: 'tire-pressure',
    indicatorField: 'tire_pressure_lamp.rear_outer_right'
  },
  tractionControl: {
    fontClass: 'traction-control',
    indicatorField: 'traction_control_lamp'
  },
  waterInFuel: {
    fontClass: 'water-in-fuel',
    indicatorField: 'water_in_fuel_lamp'
  }
};
function normalizedIndicatorValues(indicators) {
  const normalizedIndicators = {};
  (0, _lodash.forIn)(indicatorMetadata, (v, k) => {
    normalizedIndicators[k] = (0, _lodash.has)(indicators, v.indicatorField + '.value') ? (0, _lodash.get)(indicators, v.indicatorField + '.value') : (0, _lodash.get)(indicators, v.indicatorField);
  });
  return normalizedIndicators;
}
function normalizedIndicatorToFontClass(indicatorName) {
  return (0, _lodash.get)(indicatorMetadata, indicatorName + '.fontClass') || 'unknown';
}